import React from "react";
import PropTypes from "prop-types";
import ReactGA from "react-ga";
import { Checkbox } from "@blueprintjs/core";
import styles from "../../../styles/FilterSection.module.scss";
import { TAG_TYPE } from "../../../constants";

class ReportTypeFilterSection extends React.Component {
  static propTypes = {
    tagType: PropTypes.string.isRequired,
    selected: PropTypes.array,
    onFilterChange: PropTypes.func.isRequired,
    isSingleInput: PropTypes.bool,
  };

  static defaultProps = {
    selected: [],
    isSingleInput: true,
  };

  handleReportTypeChange = (event) => {
    const isEnabled = event.target.checked;
    const isIncludeDetailedView = this.props.tagType === TAG_TYPE.INCLUDE_DETAILED_VIEW;

    const filter = {
      id: isIncludeDetailedView ? "include_detailed_view" : "report_type",
      type: this.props.tagType,
      displayName: isIncludeDetailedView
        ? isEnabled
          ? "On"
          : "Off"
        : isEnabled
        ? "Advanced"
        : "Basic",
      value: isEnabled,
      isSingleSelect: true,
    };

    ReactGA.event({
      category: "filter",
      action: "report_type_select",
      label: isEnabled ? "on" : "off",
    });

    this.props.onFilterChange(filter);
  };

  render() {
    const { selected } = this.props;
    const isEnabled = selected.length > 0 ? selected[0].value : false;

    return (
      <div className={styles.radioFilterContainer}>
        <Checkbox
          checked={isEnabled}
          onChange={this.handleReportTypeChange}
          className={styles.checkbox}
        />
      </div>
    );
  }
}

export default ReportTypeFilterSection;
